import styled, { css } from 'styled-components'
import Flex from '../../Layout/Flex/Flex'

interface MainProps {
  $settlements: boolean;
}

const Main = styled(Flex).attrs<MainProps>({
  as: 'main',
  flexDirection: 'column',
  justifyContent: 'flex-start',
})`
  min-height: calc(100vh ${props => `- ${props.theme.size.headerHeight || 0} - ${props.theme.size.footerHeight || 0}`});

  ${props => props.$settlements && css`
    min-block-size: calc(100vb - ${props.theme.size.headerHeight || 0} - 40px);
  `}
`

export default Main
